module.exports = __webpack_public_path__ + "static/media/Silver-Host-Distributor.20830ba7.png";